/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Experience_Current_HintInputs */

const en_us2_profile_editors_experience_current_hint = /** @type {(inputs: Profile_Editors_Experience_Current_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan builds on what you already do`)
};

const pt_br2_profile_editors_experience_current_hint = /** @type {(inputs: Profile_Editors_Experience_Current_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano parte do que você já faz`)
};

const es_419_profile_editors_experience_current_hint = /** @type {(inputs: Profile_Editors_Experience_Current_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan parte de lo que ya haces`)
};

const pt_pt2_profile_editors_experience_current_hint = /** @type {(inputs: Profile_Editors_Experience_Current_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano parte do que já fazes`)
};

const fr_fr2_profile_editors_experience_current_hint = /** @type {(inputs: Profile_Editors_Experience_Current_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le programme part de ce que tu fais déjà`)
};

const de_de2_profile_editors_experience_current_hint = /** @type {(inputs: Profile_Editors_Experience_Current_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Plan baut auf dem auf, was du schon machst`)
};

const it_it2_profile_editors_experience_current_hint = /** @type {(inputs: Profile_Editors_Experience_Current_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda parte da quello che fai già`)
};

/**
* | output |
* | --- |
* | "The plan builds on what you already do" |
*
* @param {Profile_Editors_Experience_Current_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_experience_current_hint = /** @type {((inputs?: Profile_Editors_Experience_Current_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Experience_Current_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_experience_current_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_experience_current_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_experience_current_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_experience_current_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_experience_current_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_experience_current_hint(inputs)
	return en_us2_profile_editors_experience_current_hint(inputs)
});
export { profile_editors_experience_current_hint as "profile-editors.experience_current_hint" }